// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"_1EX4Qrb4","label":"_7TcF2Qfr","dollarSign":"_18xE3adV","input":"_2FKhXB2L"};